import React, { useEffect, useRef, useState } from "react";
import { Share2, X, Copy, Instagram, Link as LinkIcon } from "lucide-react";
import { toast } from "sonner";
import { intentUrls, SHARE_URL, nativeShare, hasNativeShare } from "../lib/share";

// Lightweight inline SVGs for platforms lucide doesn't ship a perfect logo for.
const Glyph = {
    x: (
        <svg viewBox="0 0 24 24" className="h-4 w-4" fill="currentColor" aria-hidden="true">
            <path d="M18.244 2H21.5l-7.5 8.57L23 22h-6.84l-5.34-6.99L4.74 22H1.48l8.02-9.16L1 2h6.99l4.83 6.39L18.244 2zm-1.2 18h1.84L7.04 4h-1.9l11.9 16z" />
        </svg>
    ),
    facebook: (
        <svg viewBox="0 0 24 24" className="h-4 w-4" fill="currentColor" aria-hidden="true">
            <path d="M22 12a10 10 0 1 0-11.563 9.876v-6.987H7.898V12h2.539V9.797c0-2.506 1.493-3.89 3.776-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.772-1.63 1.563V12h2.773l-.443 2.89h-2.33v6.987A10.002 10.002 0 0 0 22 12z" />
        </svg>
    ),
    reddit: (
        <svg viewBox="0 0 24 24" className="h-4 w-4" fill="currentColor" aria-hidden="true">
            <path d="M22 12.07c0-1.21-.99-2.2-2.2-2.2-.6 0-1.14.24-1.54.63-1.5-1.05-3.55-1.72-5.8-1.8l1.18-3.7 3.18.73c.02.92.77 1.66 1.7 1.66.94 0 1.7-.76 1.7-1.7s-.76-1.7-1.7-1.7c-.67 0-1.24.39-1.52.95l-3.6-.82a.5.5 0 0 0-.59.34l-1.4 4.38c-2.28.08-4.35.74-5.86 1.8a2.19 2.19 0 0 0-1.55-.63A2.2 2.2 0 0 0 2 12.07c0 .85.49 1.59 1.2 1.95-.05.24-.07.49-.07.73 0 3.3 4.04 5.97 9 5.97s9-2.67 9-5.97c0-.24-.02-.49-.07-.73.71-.36 1.2-1.1 1.2-1.95zM8 13.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5S10.33 15 9.5 15 8 14.33 8 13.5zm7.93 3.5c-.99.78-2.51 1.16-3.93 1.16s-2.94-.39-3.93-1.16a.5.5 0 1 1 .62-.78c.78.62 2.06.94 3.31.94s2.53-.32 3.31-.94a.5.5 0 1 1 .62.78zm-1.43-2c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z" />
        </svg>
    ),
    whatsapp: (
        <svg viewBox="0 0 24 24" className="h-4 w-4" fill="currentColor" aria-hidden="true">
            <path d="M.057 24l1.687-6.163a11.867 11.867 0 0 1-1.587-5.946C.157 5.335 5.492 0 12.05 0a11.82 11.82 0 0 1 8.413 3.488 11.82 11.82 0 0 1 3.48 8.414c-.003 6.557-5.338 11.892-11.893 11.892a11.9 11.9 0 0 1-5.688-1.448L.057 24zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884a9.86 9.86 0 0 0 1.522 5.273l-.999 3.648 3.966-1.02zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.149-.173.198-.297.297-.495.099-.198.05-.372-.025-.521-.074-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51l-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413z" />
        </svg>
    ),
    telegram: (
        <svg viewBox="0 0 24 24" className="h-4 w-4" fill="currentColor" aria-hidden="true">
            <path d="M9.78 18.65l.28-4.23 7.68-6.92c.34-.31-.07-.46-.52-.19L7.74 13.3 3.64 12c-.88-.25-.89-.86.2-1.3l15.97-6.16c.73-.33 1.43.18 1.15 1.3l-2.72 12.81c-.19.91-.74 1.13-1.5.71L12.6 16.3l-1.99 1.93c-.23.23-.42.42-.83.42z" />
        </svg>
    ),
};

export default function SharePopover({ text, url = SHARE_URL, getFile, label = "Share", size = "md", testIdPrefix = "share", variant = "outline" }) {
    const [open, setOpen] = useState(false);
    const containerRef = useRef(null);

    useEffect(() => {
        if (!open) return;
        const onClick = (e) => {
            if (containerRef.current && !containerRef.current.contains(e.target)) setOpen(false);
        };
        document.addEventListener("mousedown", onClick);
        document.addEventListener("touchstart", onClick);
        return () => {
            document.removeEventListener("mousedown", onClick);
            document.removeEventListener("touchstart", onClick);
        };
    }, [open]);

    const handleNative = async () => {
        let file = null;
        if (typeof getFile === "function") {
            try { file = await getFile(); } catch (e) { /* ignore */ }
        }
        const result = await nativeShare({ file, text, url });
        if (result === "copy") toast.success("Share text + link copied to clipboard");
        else if (result === "unavailable") toast.error("Sharing not supported on this device");
        setOpen(false);
    };

    const openIntent = (href) => {
        // Use noopener to avoid window.opener leaks; popup window for desktop.
        const w = window.open(href, "_blank", "noopener,noreferrer,width=600,height=540");
        if (!w) toast.error("Pop-up blocked — allow pop-ups to share");
        setOpen(false);
    };

    const intents = intentUrls({ text, url });

    const handleInstagram = async () => {
        // Instagram has no web share intent. Copy the caption + open Instagram.
        let copyOk = false;
        try {
            await navigator.clipboard.writeText(`${text} ${url}`);
            copyOk = true;
        } catch (e) { /* ignore */ }
        if (typeof getFile === "function") {
            try {
                const file = await getFile();
                if (file) {
                    // Trigger card download so user can attach it to their IG story.
                    const a = document.createElement("a");
                    const blobUrl = URL.createObjectURL(file);
                    a.href = blobUrl;
                    a.download = file.name || "hypergains-share.png";
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                    setTimeout(() => URL.revokeObjectURL(blobUrl), 500);
                }
            } catch (e) { /* ignore */ }
        }
        toast.message("Card saved + caption copied", {
            description: copyOk ? "Open Instagram and paste into your story / post." : "Open Instagram and attach the saved card.",
        });
        setOpen(false);
    };

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(`${text} ${url}`);
            toast.success("Link + caption copied");
        } catch (e) {
            toast.error("Could not copy");
        }
        setOpen(false);
    };

    const btnSize = size === "lg"
        ? "px-5 py-3 text-sm"
        : size === "sm"
            ? "px-3 py-1.5 text-[11px]"
            : "px-4 py-2 text-xs";
    const btnVariant = variant === "primary"
        ? "border border-accent-red bg-accent-red text-white hover:bg-[color:var(--accent-hover)]"
        : "border border-white/30 bg-white/5 text-white hover:bg-white/10";

    return (
        <div ref={containerRef} className="relative inline-block">
            <button
                type="button"
                onClick={() => { if (hasNativeShare()) handleNative(); else setOpen((o) => !o); }}
                data-testid={`${testIdPrefix}-button`}
                className={`inline-flex items-center gap-2 rounded-sm font-bold uppercase tracking-wider transition ${btnVariant} ${btnSize}`}
            >
                <Share2 className="h-4 w-4" /> {label}
            </button>
            {/* Desktop popover — only shown when no native share. */}
            {open && !hasNativeShare() && (
                <div
                    role="menu"
                    data-testid={`${testIdPrefix}-popover`}
                    className="absolute right-0 z-50 mt-2 w-60 origin-top-right border border-border bg-card p-2 shadow-[0_12px_36px_-4px_rgba(0,0,0,0.6)]"
                >
                    <div className="flex items-center justify-between border-b border-border px-2 pb-2">
                        <span className="label-eyebrow text-accent-red">Share to</span>
                        <button onClick={() => setOpen(false)} aria-label="Close" className="rounded-sm p-1 text-muted-foreground hover:bg-secondary"><X className="h-3.5 w-3.5" /></button>
                    </div>
                    <div className="mt-2 grid grid-cols-1 gap-1">
                        <Item icon={Glyph.x} label="X (Twitter)" onClick={() => openIntent(intents.x)} testId={`${testIdPrefix}-x`} />
                        <Item icon={Glyph.facebook} label="Facebook (post)" onClick={() => openIntent(intents.facebook)} testId={`${testIdPrefix}-facebook`} />
                        <Item icon={Glyph.facebook} label="Messenger (chat)" onClick={() => openIntent(intents.messenger)} testId={`${testIdPrefix}-messenger`} />
                        <Item icon={<Instagram className="h-4 w-4" />} label="Instagram (save card)" onClick={handleInstagram} testId={`${testIdPrefix}-instagram`} />
                        <Item icon={Glyph.reddit} label="Reddit" onClick={() => openIntent(intents.reddit)} testId={`${testIdPrefix}-reddit`} />
                        <Item icon={Glyph.whatsapp} label="WhatsApp" onClick={() => openIntent(intents.whatsapp)} testId={`${testIdPrefix}-whatsapp`} />
                        <Item icon={Glyph.telegram} label="Telegram" onClick={() => openIntent(intents.telegram)} testId={`${testIdPrefix}-telegram`} />
                        <div className="my-1 h-px bg-border" />
                        <Item icon={<Copy className="h-4 w-4" />} label="Copy link + caption" onClick={handleCopy} testId={`${testIdPrefix}-copy`} />
                    </div>
                    <p className="mt-2 px-2 text-[10px] text-muted-foreground">
                        <LinkIcon className="mr-1 inline h-2.5 w-2.5" /> Friends opening the link land on Hypergains.
                    </p>
                </div>
            )}
        </div>
    );
}

function Item({ icon, label, onClick, testId }) {
    return (
        <button
            role="menuitem"
            onClick={onClick}
            data-testid={testId}
            className="flex w-full items-center gap-3 rounded-sm px-2 py-2 text-left text-xs font-bold uppercase tracking-wider text-foreground hover:bg-secondary"
        >
            <span className="text-accent-red">{icon}</span>
            <span>{label}</span>
        </button>
    );
}
